import { render, staticRenderFns } from "./SimdelSoftLinksPage.vue?vue&type=template&id=31ba26d4&"
import script from "./SimdelSoftLinksPage.vue?vue&type=script&lang=js&"
export * from "./SimdelSoftLinksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports